import React from "react";


function DataScience() {
  
    return (
<div><p>Data science area</p></div>
    )
    
}

export default DataScience